import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

const FAQ_DATA = [
  {
    category: "サービスについて",
    icon: "ri-information-line",
    items: [
      {
        q: "TSUGITEはどのようなサイトですか？",
        a: "TSUGITEは、事業者ごとの販売ページを通じて、技術系の動画講座や教材キットを購入・学習できる教育ECモールです。購入者は無料サンプル動画やレビューを確認しながら学びたい事業者を選ぶことができます。",
      },
      {
        q: "求人サイトですか？",
        a: "いいえ。TSUGITEは求人一覧サイトではなく、技術を学ぶための教育ECモールです。購入者と事業者がメッセージ機能を通じて個別にやり取りすることはありますが、当サイトは採用や雇用の仲介を行うものではありません。",
      },
      {
        q: "無料で使えますか？",
        a: "会員登録、事業者ページの閲覧、無料サンプル動画の視聴は無料です。動画講座や教材キットの購入には料金が発生します。",
      },
    ],
  },
  {
    category: "購入・受講について",
    icon: "ri-shopping-bag-line",
    items: [
      {
        q: "購入後に事業者へ質問できますか？",
        a: "はい。購入済みの講座または教材キットがある事業者に対して、購入者限定でメッセージを送ることができます。",
      },
      {
        q: "どのような支払い方法がありますか？",
        a: "サイト上で案内される決済方法をご利用いただけます。具体的な決済方法は購入手続き画面でご確認ください。",
      },
      {
        q: "動画講座は購入後すぐ視聴できますか？",
        a: "原則として、決済完了後すぐに視聴可能となります。ただし、通信環境やシステム状況により反映に時間がかかる場合があります。",
      },
      {
        q: "動画講座は返品・返金できますか？",
        a: "デジタルコンテンツの性質上、購入後の返品・返金は原則としてお受けしていません。ただし、当サイトまたは出品内容に重大な不具合がある場合はこの限りではありません。詳細はお問い合わせフォームよりご連絡ください。",
      },
      {
        q: "教材キットは返品できますか？",
        a: "教材キットの返品・交換条件は、法令上認められる場合を除き、各事業者の定める条件に従います。商品説明欄や個別案内をご確認ください。",
      },
    ],
  },
  {
    category: "フォロー・メッセージ機能",
    icon: "ri-heart-line",
    items: [
      {
        q: "事業者をフォローすると何ができますか？",
        a: "フォローした事業者の新着商品や更新情報を確認しやすくなります。気になる事業者を継続的に追いやすくなる機能です。マイページのフォロー一覧から、最新の講座や教材を確認できます。",
      },
      {
        q: "管理者はメッセージを見ることがありますか？",
        a: "はい。安全管理、規約違反調査、トラブル対応のため、管理者が必要に応じてメッセージ内容を確認する場合があります。これはご利用規約に明記しています。",
      },
    ],
  },
  {
    category: "事業者として出品する",
    icon: "ri-store-2-line",
    items: [
      {
        q: "事業者として出品するにはどうすればよいですか？",
        a: "会員登録後、事業者モードへ切り替え、プロフィールや理念情報を設定したうえで、動画講座や教材キットを出品できます。事前承認は不要で、登録後すぐに出品を開始できます。",
      },
      {
        q: "フリープランとライトプランの違いは何ですか？",
        a: "フリープランは月額0円で、動画3本・教材3点まで出品可能です。動画販売手数料20%・教材手数料15%がかかります。ライトプランは月額5,000円で、動画・教材ともに無制限で出品でき、手数料も動画10%・教材8%に抑えられます。また、売上分析や購入者動向表示、特集掲載候補への追加などの機能も利用できます。",
      },
      {
        q: "フリープランで動画を4本以上出せますか？",
        a: "はい。フリープランでも、追加動画枠を月額1,500円で購入することで動画本数を増やせます。ただし、本数が増える場合はライトプランへの移行の方がコスト的に有利なことがあります。事業者マイページのプラン管理からご確認ください。",
      },
    ],
  },
  {
    category: "安全・通報・規約",
    icon: "ri-shield-check-line",
    items: [
      {
        q: "通報機能とは何ですか？",
        a: "動画講座、教材キット、事業者ページ、レビュー、メッセージなどに問題があると感じた場合、ユーザーは通報できます。管理者が内容を確認し、未対応・確認中・対応済み・却下のステータス管理のもと、必要に応じて削除・非表示・警告・アカウント停止などの対応を行います。",
      },
    ],
  },
  {
    category: "アカウント・その他",
    icon: "ri-account-circle-line",
    items: [
      {
        q: "アカウント情報を変更したいです。",
        a: "マイページから変更できる範囲の情報は、ご自身で更新できます。変更できない事項がある場合は、お問い合わせフォームをご利用ください。",
      },
      {
        q: "退会したい場合はどうすればよいですか？",
        a: "マイページまたはサイト上の案内に従って退会手続きを行ってください。なお、法令上または運営上必要な情報は、一定期間保持される場合があります。",
      },
    ],
  },
];

function AccordionItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      className={`border rounded-xl overflow-hidden transition-all duration-200 ${
        open ? "border-teal/30 bg-teal/2" : "border-stone-100 bg-white"
      }`}
    >
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer group"
      >
        <div className="flex items-start gap-3 flex-1 min-w-0 pr-3">
          <span className="text-teal font-serif text-base mt-0.5 shrink-0">Q.</span>
          <p className="text-sm font-sans text-charcoal font-medium leading-snug">{q}</p>
        </div>
        <div
          className={`w-7 h-7 flex items-center justify-center rounded-full transition-all duration-300 shrink-0 ${
            open ? "bg-teal text-white" : "bg-stone-100 text-charcoal/40 group-hover:bg-stone-200"
          }`}
        >
          <i className={`ri-arrow-down-s-line text-sm transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
        </div>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          open ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-5 pb-5 flex gap-3">
          <span className="text-gold font-serif text-base shrink-0">A.</span>
          <p className="text-sm font-sans text-charcoal/70 leading-relaxed">{a}</p>
        </div>
      </div>
    </div>
  );
}

export default function FaqPage() {
  const [visible, setVisible] = useState(false);
  const [activeCategory, setActiveCategory] = useState<string | null>(null);

  useEffect(() => {
    setTimeout(() => setVisible(true), 80);
  }, []);

  const allQuestions = FAQ_DATA.flatMap((cat) =>
    cat.items.map((item) => ({ ...item, category: cat.category }))
  );
  const totalCount = allQuestions.length;

  return (
    <div
      className={`min-h-screen bg-ivory flex flex-col transition-opacity duration-700 ${
        visible ? "opacity-100" : "opacity-0"
      }`}
    >
      <Navbar />

      {/* Hero */}
      <section className="pt-16">
        <div className="bg-deep-green text-white py-16 px-4 text-center relative overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <img
              src="https://public.readdy.ai/ai/img_res/14df2702945e10afab31be47044394a4.jpg"
              className="w-full h-full object-cover"
              alt=""
            />
          </div>
          <div className="relative max-w-2xl mx-auto">
            <p className="font-display italic text-gold text-xs tracking-widest mb-3">FAQ</p>
            <h1 className="font-serif text-white text-3xl md:text-4xl font-light mb-4">
              よくある質問
            </h1>
            <p className="text-white/70 text-sm font-sans leading-relaxed">
              TSUGITEは、ニッチなサービス業の技術を学べる教育ECモールです。<br />
              ここでは、購入者・事業者の双方からよく寄せられる質問をまとめています。<br className="hidden md:block" />
              解決しない場合は、お問い合わせフォームよりご連絡ください。
            </p>
          </div>
        </div>
      </section>

      <main className="max-w-screen-lg mx-auto w-full px-4 md:px-8 py-12 flex-1">
        {/* Stats */}
        <div className="flex items-center justify-center gap-6 mb-10 text-center">
          <div>
            <p className="font-serif text-deep-green text-2xl">{totalCount}</p>
            <p className="text-xs text-charcoal/40 font-sans">Q&amp;A</p>
          </div>
          <div className="w-px h-8 bg-stone-200" />
          <div>
            <p className="font-serif text-deep-green text-2xl">{FAQ_DATA.length}</p>
            <p className="text-xs text-charcoal/40 font-sans">カテゴリ</p>
          </div>
        </div>

        {/* Category filter pills */}
        <div className="flex flex-wrap gap-2 justify-center mb-10">
          <button
            onClick={() => setActiveCategory(null)}
            className={`px-4 py-2 rounded-full text-sm font-sans cursor-pointer border transition-all duration-200 whitespace-nowrap ${
              activeCategory === null
                ? "bg-deep-green text-white border-deep-green"
                : "border-stone-200 text-charcoal/60 hover:border-stone-400 bg-white"
            }`}
          >
            すべて
          </button>
          {FAQ_DATA.map((cat) => (
            <button
              key={cat.category}
              onClick={() => setActiveCategory(activeCategory === cat.category ? null : cat.category)}
              className={`px-4 py-2 rounded-full text-sm font-sans cursor-pointer border transition-all duration-200 whitespace-nowrap flex items-center gap-1.5 ${
                activeCategory === cat.category
                  ? "bg-deep-green text-white border-deep-green"
                  : "border-stone-200 text-charcoal/60 hover:border-stone-400 bg-white"
              }`}
            >
              <i className={`${cat.icon} text-xs`} />
              {cat.category}
            </button>
          ))}
        </div>

        {/* FAQ Content */}
        <div className="space-y-10">
          {FAQ_DATA.filter((cat) => !activeCategory || cat.category === activeCategory).map(
            (cat) => (
              <section key={cat.category}>
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-deep-green/8">
                    <i className={`${cat.icon} text-deep-green text-base`} />
                  </div>
                  <div>
                    <h2 className="font-serif text-deep-green text-lg">{cat.category}</h2>
                    <p className="text-xs text-charcoal/40 font-sans">{cat.items.length}件</p>
                  </div>
                </div>
                <div className="space-y-2">
                  {cat.items.map((item) => (
                    <AccordionItem key={item.q} q={item.q} a={item.a} />
                  ))}
                </div>
              </section>
            )
          )}
        </div>

        {/* Contact CTA */}
        <div className="mt-16 bg-white rounded-2xl border border-stone-100 p-8 text-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-teal/10 mx-auto mb-4">
            <i className="ri-customer-service-2-line text-2xl text-teal" />
          </div>
          <h3 className="font-serif text-deep-green text-xl mb-2">解決しませんでしたか？</h3>
          <p className="text-sm text-charcoal/60 font-sans leading-relaxed mb-6">
            お探しの回答が見つからない場合は、お問い合わせフォームよりご連絡ください。<br />
            通常2〜3営業日以内にご返答いたします。
          </p>
          <Link
            to="/contact"
            className="btn-primary inline-block text-sm px-8 py-3"
          >
            お問い合わせフォームへ →
          </Link>
          <div className="mt-6 flex items-center justify-center gap-6">
            <Link to="/terms" className="text-xs text-charcoal/40 hover:text-teal cursor-pointer transition-colors font-sans">
              利用規約
            </Link>
            <Link to="/privacy" className="text-xs text-charcoal/40 hover:text-teal cursor-pointer transition-colors font-sans">
              プライバシーポリシー
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
